const EXTENSION_BY_CONTENT_TYPE: Record<string, string> = {
  'application/pdf': 'pdf',
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
  'application/vnd.ms-outlook': 'msg',
  'application/rtf': 'rtf',
  'application/zip': 'zip',
  'message/rfc822': 'eml',
  'text/csv': 'csv',
  'text/plain': 'txt',
  'text/html': 'html',
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/tiff': 'tiff',
  'image/heic': 'heic',
  'image/svg+xml': 'svg',
}

// A superset of the map's values: a name can end in an extension no content type maps back to, and
// appending to it would save `contract.doc` as `contract.doc.pdf`.
const KNOWN_EXTENSIONS = new Set([
  ...Object.values(EXTENSION_BY_CONTENT_TYPE),
  'jpeg',
  'tif',
  'htm',
  'xml',
  'json',
  'md',
  'odt',
  'ods',
  '7z',
  'rar',
  'gz',
])

// Set membership, not a dot pattern: a pattern reads `Acme MSA v2.1` as ending in `.1` and leaves the
// download unopenable.
export const recoverFileExtension = ({
  fileName,
  contentType,
}: {
  fileName: string
  contentType: string
}): { fileName: string; hadKnownExtension: boolean } => {
  const lastDot = fileName.lastIndexOf('.')
  const trailingToken = lastDot === -1 ? '' : fileName.slice(lastDot + 1).toLowerCase()
  if (KNOWN_EXTENSIONS.has(trailingToken)) return { fileName, hadKnownExtension: true }

  const mediaType = (contentType.split(';')[0] ?? '').trim().toLowerCase()
  const extension = EXTENSION_BY_CONTENT_TYPE[mediaType]
  if (!extension) return { fileName, hadKnownExtension: false }

  return {
    fileName: fileName.endsWith('.') ? `${fileName}${extension}` : `${fileName}.${extension}`,
    hadKnownExtension: false,
  }
}
